module.exports = __webpack_public_path__ + "static/media/certificates.f06f860d.jpg";